export function isTokenProvider(provider) {
    return !!provider.useToken;
}
